/* Offcourt Club – Teilen-Knöpfe in den Tools
   Turnier: Siegertreppchen und Live-Link als Story · Training: „Einheit geschafft“ nach jeder
   Einheit · Schläger-Finder: Ergebnis teilen. Dazu ein einheitlicher Teilen-Knopf im Tool-Kopf und
   in der Turnier-Rangliste „Zeigen & Teilen“ statt vieler einzelner Knöpfe. */
(function(){
  var TOOL = window.OC_TOOL_NAME || '';
  var app = document.getElementById('oc-app');
  var S = window.ocShare;
  if (!app || !S) return;
  function get(k){ try { return JSON.parse(localStorage.getItem(k)); } catch(e){ return null; } }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function watch(fn){ var busy = false; new MutationObserver(function(){ if (busy) return; busy = true; try { fn(); } finally { busy = false; } }).observe(app, {childList: true, subtree: true}); fn(); }

  /* Hinweise laufen über den gemeinsamen Kanal aus oc-ux.js (immer nur einer, nie während Match oder Training) */
  function toast(icon, title, text, label, onGo){ if (window.ocToast) window.ocToast({prio: 3, icon: icon, title: title, text: text, actions: [{label: label, fn: onGo}]}); }
  window.ocSocial = {toast: toast};
  /* Messung: wie oft wird welches Bild geteilt */
  var origShare = S.share;
  S.share = function(o){ if (window.ocTrack) window.ocTrack('share_open', {kind: o.kind || (o.match ? 'match' : 'ranking')}); return origShare.apply(S, arguments); };

  /* ---------- Turnier: Rangliste / Siegertreppchen ---------- */
  if (TOOL === 'turnier'){
    watch(function(){
      var tbl = app.querySelector('#oc-main .card.tblw');
      if (!tbl || app.querySelector('#ocShareRank')) return;
      var info = (app.querySelector('#oc-main .sub') || {}).textContent || '';
      var m = info.match(/(\d+) von (\d+)/), all = !!(m && m[1] === m[2]);
      var row = document.createElement('div'); row.className = 'row';
      row.innerHTML = '<button class="btn" id="ocShareRank" type="button">' + (all ? 'Siegertreppchen teilen' : 'Zwischenstand teilen') + '</button><span class="note" id="ocShareMsg"></span>';
      tbl.insertAdjacentElement('afterend', row);
      row.querySelector('button').onclick = function(){
        var rows = [].map.call(app.querySelectorAll('#oc-main .card.tblw tbody tr'), function(tr, k){ var td = tr.querySelectorAll('td'); return {pos: k + 1, name: td[1].textContent.trim(), val: td[2].textContent.trim()}; });
        if (!rows.length){ row.querySelector('#ocShareMsg').textContent = 'Noch keine Rangliste vorhanden.'; return; }
        var t = get('oc-turnierplaner-v1') || {}, mode = t.mode ? (t.mode === 'mexicano' ? 'Mexicano' : 'Americano') + ' · ' : '';
        S.share({kind: 'ranking', kicker: all ? 'Endstand' : 'Zwischenstand', final: all, title: t.name || 'Padel-Turnier',
          sub: mode + rows.length + ' Spieler · ' + new Date().toLocaleDateString('de-DE'), rows: rows, footer: 'Erstellt mit dem Offcourt Turnierplaner'}, 'offcourt-rangliste');
      };
    });
    app.addEventListener('click', function(e){
      if (!e.target.closest || !e.target.closest('#ocLiveStory')) return;
      var L = get('oc-live-v1'), t = get('oc-turnierplaner-v1') || {};
      if (!L || !L.id) return;
      S.share({kind: 'live', kicker: 'Live', live: {title: t.name || 'Padel-Turnier', url: location.origin + '/pages/turnier-live?t=' + L.id}, footer: 'Live mit dem Offcourt Turnierplaner'}, 'offcourt-live');
    });
    /* Live-Link als Story (die Live-Karte wird beim Senden neu gezeichnet – Knopf dann wieder ergänzen) */
    watch(function(){
      var sh = app.querySelector('.olv-card #olvShare');
      if (sh && !app.querySelector('#ocLiveStory')){ var b = document.createElement('button'); b.type = 'button'; b.className = 'btn sm sec'; b.id = 'ocLiveStory'; b.textContent = 'Als Story teilen'; sh.insertAdjacentElement('afterend', b); }
    });
  }

  /* ---------- Training: nach jeder abgeschlossenen Einheit ---------- */
  function weekKey(d){ var x = new Date(d); x.setHours(0,0,0,0); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x.getTime(); }
  function streak(dates){
    var weeks = {}; dates.forEach(function(d){ weeks[weekKey(d)] = 1; });
    var w = weekKey(new Date()), n = 0, prev = function(k){ var d = new Date(k); d.setDate(d.getDate() - 7); return weekKey(d); };
    if (!weeks[w]) w = prev(w);
    while (weeks[w]){ n++; w = prev(w); }
    return n;
  }
  var CATS = {warm:'Aufwärmen', grund:'Grundschläge', wand:'Wandspiel', volley:'Volley & Netz', lob:'Lob & Defensive', ueber:'Überkopf', serve:'Aufschlag & Return', taktik:'Taktik', bein:'Beinarbeit', mix:'Gemischt'};
  ((window.OC_DATA && window.OC_DATA.cats) || []).forEach(function(c){ if (c && c[0]) CATS[c[0]] = c[1]; });
  function shareTraining(l){
    var log = ((get('oc-training-v1') || {}).log || []).filter(function(x){ return !x.ex && x.date; });
    var focus = (l.focus || []).map(function(c){ return CATS[c] || c; });
    S.share({kind: 'training', kicker: 'Training', training: {min: l.min || 0, drills: l.drills || 0, goals: l.goals || 0, focus: focus, streak: Math.max(1, streak(log.map(function(x){ return x.date; })))}, footer: 'Trainiert mit dem Offcourt Trainings-Generator'}, 'offcourt-training');
  }
  window.ocSocial.shareTraining = shareTraining;
  if (TOOL === 'training'){
    var seen = {};
    (((get('oc-training-v1') || {}).log) || []).forEach(function(l){ seen[l.date] = 1; });
    var prevSet = Storage.prototype.setItem;
    Storage.prototype.setItem = function(k, v){
      prevSet.apply(this, arguments);
      if (k !== 'oc-training-v1') return;
      var log = []; try { log = (JSON.parse(v) || {}).log || []; } catch(e){}
      log.forEach(function(l){
        if (!l || !l.date || seen[l.date]) return;
        seen[l.date] = 1;
        if (l.ex || Date.now() - new Date(l.date).getTime() > 600000) return;
        setTimeout(function(){ toast('💪', 'Einheit geschafft!', (l.min || 0) + ' Minuten – zeig es deinen Leuten.', 'Teilen', function(){ shareTraining(l); }); }, 600);
      });
    };
  }

  /* ---------- Schläger-Finder: Ergebnis teilen ---------- */
  if (TOOL === 'finder'){
    watch(function(){
      var why = app.querySelector('#oc-main .why');
      if (!why || app.querySelector('#ocShareFinder')) return;
      var h1 = (app.querySelector('#oc-main h1') || {}).textContent || '';
      var perf = /Performance/i.test(h1), note = (app.querySelector('#oc-main > .stack > .note') || {}).textContent || '';
      var pct = (note.match(/(\d+)\s*%/) || [])[1];
      var row = document.createElement('div'); row.className = 'row';
      row.innerHTML = '<button class="btn sec" id="ocShareFinder" type="button">Mein Ergebnis teilen</button><span class="note">Welcher Typ sind deine Mitspieler?</span>';
      var card = why.closest('.card'); (card || why).insertAdjacentElement('afterend', row);
      row.querySelector('button').onclick = function(){
        var lines = [].map.call(app.querySelectorAll('#oc-main .why li'), function(li){ return li.textContent.trim(); });
        S.share({kind: 'finder', kicker: 'Schläger-Finder', finder: {type: perf ? 'Power' : 'Kontrolle', model: h1.trim(), pct: pct, why: lines}, footer: 'Ermittelt mit dem Offcourt Schläger-Finder'}, 'offcourt-schlaegertyp');
      };
    });
  }

  /* ---------- Auswahl-Fenster (Zeigen & Teilen) ---------- */
  function sheet(title, items){
    var el = document.createElement('div'); el.className = 'ocz-sheet'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', title);
    el.innerHTML = '<div class="in"><div class="hd"><b>' + esc(title) + '</b><button type="button" class="ocu-x">Schließen</button></div>' +
      items.map(function(it, i){ return '<button type="button" class="opt" data-i="' + i + '"' + (it.off ? ' aria-disabled="true"' : '') + '><span class="e" aria-hidden="true">' + it.icon + '</span><span><b>' + esc(it.title) + '</b><small>' + esc(it.text) + '</small></span>' + (it.badge ? '<em>' + esc(it.badge) + '</em>' : '') + '</button>'; }).join('') + '</div>';
    document.body.appendChild(el);
    var close = function(){ el.remove(); };
    el.querySelector('.ocu-x').onclick = close;
    el.addEventListener('click', function(e){ if (e.target === el) close(); });
    [].forEach.call(el.querySelectorAll('.opt'), function(b){ b.onclick = function(){ var it = items[+b.dataset.i]; close(); if (window.ocTrack) window.ocTrack('hub_' + it.key); it.fn(); }; });
    var f = el.querySelector('.opt'); if (f) f.focus();
  }
  function hint(t){ if (window.ocToast) window.ocToast({prio: 2, icon: 'ℹ️', title: t, text: '', ttl: 5000}); }

  function turnierHub(){
    var go = function(){
      var L = get('oc-live-v1'), live = L && L.id && L.exp > Date.now();
      sheet('Zeigen & Teilen', [
        {key: 'bild', icon: '📸', title: 'Als Bild teilen', text: 'Siegertreppchen oder Zwischenstand für Instagram & WhatsApp', fn: function(){ var b = app.querySelector('#ocShareRank'); if (b) b.click(); }},
        {key: 'live', icon: '📱', title: 'Live für Zuschauer', text: 'QR-Code und Link – Ergebnisse live auf jedem Handy', badge: live ? 'läuft' : '', fn: function(){ var c = app.querySelector('.olv-card'); if (c){ c.classList.add('ocz-open'); c.scrollIntoView({behavior: 'smooth', block: 'center'}); } }},
        {key: 'halle', icon: '🖥️', title: 'Hallen-Ansicht', text: 'Spielplan, Timer und Rangliste groß für alle', fn: function(){ var b = app.querySelector('#toHall'); if (b) b.click(); }}
      ]);
    };
    if (!app.querySelector('#tab-rank[aria-selected="true"]')){ var t = app.querySelector('#tab-rank'); if (t) t.click(); setTimeout(go, 80); } else go();
  }

  if (TOOL === 'turnier'){
    app.classList.add('ocz-on');
    watch(function(){
      var lc = app.querySelector('.olv-card');
      if (lc && lc.querySelector('.olv .qr') && !lc.classList.contains('ocz-open')) lc.classList.add('ocz-open');
      var tbl = app.querySelector('#oc-main .card.tblw');
      if (!tbl || app.querySelector('#oczHub')) return;
      var r = document.createElement('div'); r.className = 'row';
      r.innerHTML = '<button class="btn" id="oczHub" type="button">Zeigen &amp; Teilen</button><span class="note">Bild, Live-Link oder Hallen-Ansicht</span>';
      tbl.insertAdjacentElement('afterend', r);
      r.querySelector('button').onclick = turnierHub;
    });
  }

  /* ---------- Teilen-Knopf im Tool-Kopf ---------- */
  var ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="M7 8l5-5 5 5"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>';
  function headerShare(){
    if (TOOL === 'turnier') return turnierHub();
    if (TOOL === 'match'){
      var M = get('oc-match-v1');
      if (!M || !M.end) return hint('Noch kein fertiges Match – zähl eins, dann kannst du das Ergebnis teilen.');
      var s = app.querySelector('#court:not([hidden]) #share'); if (s) return s.click();
      var op = app.querySelector('#open'); if (op){ op.click(); setTimeout(function(){ var s2 = app.querySelector('#court #share'); if (s2) s2.click(); }, 80); }
      return;
    }
    if (TOOL === 'training'){
      var log = ((get('oc-training-v1') || {}).log || []).filter(function(l){ return !l.ex && l.date; }).sort(function(a, b){ return new Date(b.date) - new Date(a.date); });
      if (!log.length) return hint('Noch keine Einheit abgeschlossen – nach deiner ersten Einheit kannst du sie hier teilen.');
      return shareTraining(log[0]);
    }
    if (TOOL === 'stats'){
      if (!app.querySelector('[data-wr]')) return hint('Teilen gibt es mit deiner Club-Statistik.');
      return sheet('Rückblick teilen', [
        {key: 'monat', icon: '📅', title: 'Dieser Monat', text: 'Deine Zahlen aus diesem Monat', fn: function(){ app.querySelector('[data-wr="m"]').click(); }},
        {key: 'jahr', icon: '🗓️', title: 'Dieses Jahr', text: 'Dein Padel-Jahr auf einen Blick', fn: function(){ app.querySelector('[data-wr="y"]').click(); }}
      ]);
    }
    if (TOOL === 'finder'){
      var f = app.querySelector('#ocShareFinder'); if (f) return f.click();
      return hint('Beantworte erst die Fragen – dann kannst du dein Ergebnis teilen.');
    }
  }
  watch(function(){
    var h = app.querySelector(':scope > header');
    if (!h || h.querySelector('.ocz-hb')) return;
    var host = h.querySelector('.hd') || h;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'ocz-hb'; b.setAttribute('aria-label', 'Teilen'); b.innerHTML = ICON;
    b.onclick = headerShare;
    host.appendChild(b);
  });
})();